import { FeatureFlag, isFeatureEnabled } from "store/featureFlagsSlice"
import { useAppSelector } from "store/hooks"
import { ReactComponent as IconDevice } from "assets/svg/icon-device.svg"
import { ReactComponent as IconAlerts } from "assets/svg/menu-alerts.svg"
import { ReactComponent as IconDashboard } from "assets/svg/menu-dashboard.svg"
import { ReactComponent as IconMonitoring } from "assets/svg/menu-monitoring.svg"
import { ReactComponent as IconOrders } from "assets/svg/menu-orders.svg"

import { MenuItem, MenuItemGroup, MenuSubItem } from ".."

export const EnterpriseMenu = () => {
  const isEnterpriseIteration2Enabled = useAppSelector(isFeatureEnabled(FeatureFlag.EnterpriseIteration2))
  const isSensorsOrderingEnabled = useAppSelector(isFeatureEnabled(FeatureFlag.SensorsOrdering))

  return (
    <>
      <MenuItem to="/dashboard" icon={<IconDashboard />} label="Dashboard" />
      {isEnterpriseIteration2Enabled && (
        <>
          {isSensorsOrderingEnabled ? (
            <MenuItemGroup icon={<IconDevice />} label="Devices" basePaths={["/devices"]} iconType="stroke">
              <MenuSubItem to="/devices" label="Thermostats" />
              <MenuSubItem to="/devices/sensors" label="Sensors" />
            </MenuItemGroup>
          ) : (
            <MenuItem to="/devices" icon={<IconDevice />} label="Devices" />
          )}
        </>
      )}
      {isEnterpriseIteration2Enabled && <MenuItem to="/orders" icon={<IconOrders />} label="Orders" />}
      {isEnterpriseIteration2Enabled && <MenuItem to="/alerts" icon={<IconAlerts />} label="Alerts" />}
      {isEnterpriseIteration2Enabled && <MenuItem to="/monitoring" icon={<IconMonitoring />} label="Monitoring" />}
    </>
  )
}
